import * as AlertDialog from "@radix-ui/react-alert-dialog";

interface ConfirmationModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  onConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  onOpenChange,
  title,
  description,
  onConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
}) => {
  return (
    <AlertDialog.Root open={open} onOpenChange={onOpenChange}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="fixed inset-0 bg-gray-800/50 bg-opacity-50 z-200001" />
        <AlertDialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl shadow-xl w-full max-w-md z-200002">
          <div className="flex flex-col gap-6 items-start justify-start p-6 w-full">
            <div className="flex flex-col gap-2 items-center justify-start w-full">
              <AlertDialog.Title
                className="font-['Open_Sans'] font-bold text-[#444444] text-[16px] text-center"
                style={{ fontVariationSettings: "'wdth' 100" }}
              >
                {title}
              </AlertDialog.Title>
              <AlertDialog.Description className="font-['Open_Sans'] font-medium text-[#828282] text-[12px] text-center leading-[1.4]">
                {description}
              </AlertDialog.Description>
            </div>
            <div className="flex flex-row gap-4 items-center justify-start w-full">
              <AlertDialog.Cancel asChild>
                <button className="cursor-pointer flex-1 border border-gray-100 rounded-[10px] px-6 py-3 flex items-center justify-center">
                  <span
                    className="font-['Open_Sans'] font-semibold text-[#374795] text-[14px] leading-[1.4]"
                    style={{ fontVariationSettings: "'wdth' 100" }}
                  >
                    {cancelText}
                  </span>
                </button>
              </AlertDialog.Cancel>
              <AlertDialog.Action asChild>
                <button
                  onClick={onConfirm}
                  className="cursor-pointer flex-1 border border-[#e7000b] rounded-[10px] px-6 py-3 flex items-center justify-center"
                >
                  <span
                    className="font-['Open_Sans'] font-semibold text-[#e7000b] text-[14px] leading-[1.4]"
                    style={{ fontVariationSettings: "'wdth' 100" }}
                  >
                    {confirmText}
                  </span>
                </button>
              </AlertDialog.Action>
            </div>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
};
